import { format } from "date-fns";

import getTimezoneOffsetDate from "../get_timezone_offset_date/get_timezone_offset_date";

const DATE_FORMAT_LONG = "d LLL yyyy";
const DATE_FORMAT_SHORT = "d";

export default function formatDate(utcDateString, short = false) {
  // Use js Date object with time offset vs environment timezone
  const offsetDate = getTimezoneOffsetDate(utcDateString);
  return short
    ? format(offsetDate, DATE_FORMAT_SHORT)
    : format(offsetDate, DATE_FORMAT_LONG);
}
